import React from 'react'

const Footer = ({ productRef, contactRef }) => {
    return (
        <div className="h-72 bg-black mt-10 flex flex-col justify-end pl-20 pr-20 pb-10">
            <div className="flex justify-between items-center">
                <div className="w-52">
                    <img src="logo.png" />
                </div>
                <div className="">
                    <p className="text-gray-100">©Konnect LLC</p>
                </div>
                <div className="text-white flex space-x-20">
                    <p className="cursor-pointer" onClick={() => { productRef.current.scrollIntoView({ behavior: 'smooth' }) }}>Products</p>
                    <p className="cursor-pointer" onClick={() => { contactRef.current.scrollIntoView({ behavior: 'smooth' }) }}>Contact</p>
                </div>
            </div>

        </div>
    )
}

export default Footer
